<template>
    <div class="origin mt-4 position-relative">
        <ldc-select
            v-model="origin"
            placeholder="Chọn xuất xứ"
            class="rv-select-form" v-if="$detect == 'web'">
            <ldc-option 
                v-for="(index, key) in nation" :key="key"
                :value="index.n_id"
                :label="index.n_name"/>
        </ldc-select>
        <ldc-select-mobile
            :showPlaceholder="false"
            placeholder="Chọn xuất xứ"
            title="Loại tin"
            v-model="origin"
            class="select-mobile-post"
            v-else>
            <ldc-option-mobile
                v-for="(index, key) in nation" :key="key"
                :value="index.n_id"
                :label="index.n_name"/>
        </ldc-select-mobile>
        <div class="text-position-select position-absolute text-primary">Chọn xuất xứ</div>
      <!--   <div :class="{
                'input-focus-effect': true,
                'rv-valiadate-input-form': error
            }">
            <input :class="origin != '' ? 'border-primary' : ''" type="text" id="inputWebsite"
                v-model="origin" @focus="$emit('update:error', '')"/>
            <label :class="{
                    'mb-0': true,
                    'input-on-alue': origin != ''
                }">Xuất xứ sản phẩm</label>
        </div> -->
        <div class="text-danger fs-12px mt-1" v-if="error">{{error}}</div>
    </div>
</template>
<script>
export default {
    props: ['data', 'error'],
    data() {
        return {
            origin: '',
            nation : [],
        }
    },
    watch: {
        data(val){
            this.origin = val;
        },
        origin(val){
            this.$emit('update:data', val);
        }
    },
    created() {
        this.origin = this.data;
        apiGet('/v2/products/nation').then(res => {
            let data = res.data;
            this.nation = data;
        })
      

    }
}
</script>
